// Copy for the "Select your preferences" screen. Chrome/labels only — the offering data
// (modality, duration, provider label) comes from the BFF and is composed at render time.
// English-only literal strings, like the rest of this package.

import type { BookingOffering, Offering } from "./hooks"

// The visit-type card title + description, keyed by the offering's `appointmentType`.
const APPOINTMENT_TYPE_COPY: Record<Offering["appointmentType"], { title: string; description: string }> = {
  initial: {
    title: "Initial consult",
    description: "Your first visit with a Carrot Clinic clinician. We'll match you with the first available provider."
  },
  follow_up: {
    title: "Follow-up visit",
    description: "Continue with a Carrot Clinic clinician you've met with before."
  }
}

export function appointmentTypeCopy(appointmentType: Offering["appointmentType"]): {
  title: string
  description: string
} {
  return APPOINTMENT_TYPE_COPY[appointmentType]
}

// Shown under the disabled Follow-up card to explain why it isn't selectable yet.
export const FOLLOW_UP_HELPER_TEXT =
  "You can schedule follow-up visits with the same provider after an initial consult."

const MODALITY_LABEL: Record<BookingOffering["modality"], string> = {
  video: "Video visit"
}

// The summary line under the header, e.g. "Video visit · 45 minutes · with a Carrot Clinic clinician".
export function offeringSummaryLine(offering: BookingOffering, durationMinutes: number): string {
  return `${MODALITY_LABEL[offering.modality]} · ${durationMinutes} minutes · with a ${offering.providerLabel}`
}
